import { option } from 'fp-ts';

import { CompleteQuery, ESIndex } from 'modules/queryBuilder/types';
import { QueryBuilderForm } from 'modules/queryBuilder';
import { useCatalogContext } from 'modules/catalog/catalogSelector';
import { CollectionQueryBuilder } from 'modules/catalog/legacyQueryBuilder';
import { useFetchCatalogFields } from 'modules/catalogFieldTypes/hooks';

import { useCatalogSelectionContext } from './contexts/CatalogSelectionContext';
import { QueryBuilderWrapper } from './QueryBuilder.styled';
import { useUpdateBuilderFields } from './hooks/useUpdateBuilderFields';
import { useCatInSegQueryBuilderV2FeatureFlag } from './hooks/useCatInSegQueryBuilderV2FeatureFlag';
import { FORM_ID } from './constants';
import { useOnSubmit } from './hooks/useOnSubmit';
import { useCatalogQueryContext } from '../../contexts/catalogQuery';
import { queryBuilderVisualComponents } from './queryBuilderVisualComponents';

export const DATA_TEST = {
  qbForm: 'cat-in-seg-QB-FORM',
};

export const QueryBuilder = () => {
  const { catalog } = useCatalogContext();
  const { catalogQueryDetails, isReadOnlyOnOpen } = useCatalogQueryContext();
  const { isEnabled } = useCatalogSelectionContext();
  const { isLoading } = useFetchCatalogFields(option.toUndefined(catalog)?.name);
  useUpdateBuilderFields();
  const isFeatureFlagged = useCatInSegQueryBuilderV2FeatureFlag();
  const onSubmit = useOnSubmit();

  // not ideal but typing SearchQuery to CompleteQuery would require a lot of updating when both types are fundamentally the same
  const passedSearchQuery = catalogQueryDetails?.catalogQuery?.searchQuery as unknown as
    | CompleteQuery
    | undefined;

  if (!isEnabled) return null;

  return isFeatureFlagged ? (
    <div data-test={DATA_TEST.qbForm}>
      <QueryBuilderForm
        id={FORM_ID}
        esIndex={ESIndex.Catalog}
        catalogName={option.toUndefined(catalog)?.name}
        onSubmitSuccess={onSubmit}
        query={passedSearchQuery}
        visualComponents={queryBuilderVisualComponents}
        isReadOnly={isReadOnlyOnOpen}
      />
    </div>
  ) : (
    <QueryBuilderWrapper>
      <CollectionQueryBuilder
        showDynamicFieldToggle={false}
        showLimitAndOrderBy={false}
        isLoading={isLoading}
        disallowHandlebarsInQuery={true}
      />
    </QueryBuilderWrapper>
  );
};
